import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  OutlinedIcons,
  ContextMenuItemType,
} from '@marageti/z4-lib';
import ContextMenuComplete from '../../context-menu';

const {
  OutlinedChatIcon,
  OutlinedPencilIcon,
  OutlinedDocumentDuplicateIcon,
  OutlinedArchiveIcon,
  OutlinedDotsHorizontalIcon,
} = OutlinedIcons;

type ReminderContextMenuProps = {
  ticketId: string;
  tripRequestId?: string;
  isMobile: boolean;
  messageLink: string;
  isDismissed: boolean;
  onEdit: () => void;
  onDuplicate: () => void;
  onDismiss: () => void;
};

const ReminderContextMenu = ({
  ticketId,
  tripRequestId,
  isMobile,
  messageLink,
  isDismissed,
  onEdit,
  onDuplicate,
  onDismiss,
}: ReminderContextMenuProps) => {
  const navigate = useNavigate();

  const menuItems: ContextMenuItemType[] = isMobile
    ? [
      ...(tripRequestId
        ? [
          {
            label: 'Send Message',
            action: () => navigate(messageLink),
            icon: <OutlinedChatIcon color="primary" />,
          },
        ]
        : []),
      {
        label: 'Edit',
        action: onEdit,
        icon: <OutlinedPencilIcon color="primary" />,
      },
      {
        label: 'Duplicate',
        action: onDuplicate,
        icon: <OutlinedDocumentDuplicateIcon color="primary" />,
      },
      ...(isDismissed
        ? []
        : [
          {
            label: 'Dismiss',
            action: onDismiss,
            icon: <OutlinedArchiveIcon color="primary" />,
          },
        ]),
    ]
    : [
      {
        label: 'Duplicate',
        action: onDuplicate,
        icon: <OutlinedDocumentDuplicateIcon color="primary" />,
      },
      ...(isDismissed
        ? []
        : [
          {
            label: 'Dismiss',
            action: onDismiss,
            icon: <OutlinedArchiveIcon color="primary" />,
          },
        ]),
    ];

  return (
    <ContextMenuComplete
      id={ticketId}
      items={menuItems}
      customButtonIcon={<OutlinedDotsHorizontalIcon color="primary" />}
    />
  );
};

export default ReminderContextMenu;
